import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoTypeaheadClientePessoaComponent } from './novo-typeahead-cliente-pessoa.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoTypeaheadClientePessoaComponent],
  exports: [NovoTypeaheadClientePessoaComponent]
})
export class NovoTypeaheadClientePessoaModule {}
